










import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";
import LayoutTools from "../layout_controls/LayoutTools.vue";
import PdfViewerPaginator from "./PdfViewerPaginator.vue";

@Component({
  components: {
    "ag-pdfviewer-paginator": PdfViewerPaginator,
    "ag-layout-tools": LayoutTools,
  },
})
export default class PdfViewerTools extends Vue {
  get elemHeight() {
    return $store.appearance.pdfViewerToolbarHeight;
  }

  get hideLayoutToolbar() {
    return $store.appearance.hideLayoutToolbar;
  }

  get layoutActive() {
    return $store.wizard.layoutActive;
  }
}
